import React from "react";
import { Box, Avatar, Typography } from "@mui/material";
import Icon1 from "../icons/Icon";
import { useTheme } from "@mui/material";
import { hasInfiltro } from "../hexagone/VisibilityHelpers";

const ListCellName = ({
  user,
  removable,
  onDelete,
  icon_name = "user",
  onSetConducteur,
  folderData,
  orgData,
}) => {
  const theme = useTheme();

  // Check if this user is the current conducteur de chantier
  const isConducteur = folderData?.conductor_id === user?.id;
  const canManageConducteur = hasInfiltro(orgData) && onSetConducteur;

  return (
    <div className="flex flex-row gap-2 w-full p-2">
      {/* User Avatar and Email */}
      <div className="flex flex-row gap-2  items-center w-full">
        <img
          src={
            user?.photo ||
            "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRR2dtSs0-ybB7OnCnfsC1UWgViGQLxAtVx83IPHmxIjh1istqxGhm2sjWOSF1TDN_J-r0&usqp=CAU"
          }
          alt="photo"
          className="h-10 w-10 rounded-full"
        />
        <div className=" h-fit flex flex-col text-h3 items-start rounded-full py-1 w-full">
          <div className="flex flex-row items-center gap-2">
            <span>{user?.display_name}</span>
            {isConducteur && (
              <span className="bg-blue-50 text-blue-500 text-xs font-medium px-2 py-1 rounded-full">
                Conducteur de Chantier
              </span>
            )}
          </div>
          <div className="text-h6 text-shadow_50">
            {" "}
            {user?.email?.substring(0, 30)}
          </div>
        </div>
      </div>

      {/* Conducteur de chantier management (Infiltro users only) */}
      <div className="cursor-pointer flex justify-end items-center flex-row gap-2">
        {canManageConducteur && (
          <div
            className="cursor-pointer"
            onClick={() => onSetConducteur(user)}
            title={
              isConducteur
                ? "Retirer le rôle de Conducteur de chantier"
                : "Définir comme Conducteur de chantier"
            }
          >
            <Icon1
              icon_name={isConducteur ? "star_filled" : "star"}
              height="16px"
              width="16px"
              hover_color={isConducteur ? "orange" : "blue"}
              fill={isConducteur ? "orange" : "grey"}
            />
          </div>
        )}

        {/* Close Icon (Removable functionality) */}
        {removable && (
          <div className="cursor-pointer" onClick={() => onDelete(user)}>
            <Icon1
              icon_name="delete"
              height="16px"
              width="16px"
              hover_color={"red"}
              fill={"grey"}
            />
          </div>
        )}
      </div>
    </div>
  );
};

export default ListCellName;
